export function getCssText(): string { return `
  
  .ncp-trigger {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid var(--nile-colors-neutral-500, var(--ng-colors-border-secondary));
    padding: 0;
    cursor: pointer;
    box-sizing: border-box;
    transition: box-shadow 0.15s ease, transform 0.15s ease;
  }
  .ncp-trigger:hover {
    transform: translateY(-1px);
  }
  .ncp-trigger:focus-visible {
    outline: none;
  }
  .ncp-trigger--no-fill {
    background:
      repeating-conic-gradient(#E4E7EC 0% 25%, #FFFFFF 0% 50%)
      0 0 / 12px 12px;
  }

  /* ── inline panel ────────────────────────────────────────────────── */
  .ncp-panel {
    padding: 8px;
    background: var(--nile-colors-white-base, var(--ng-colors-bg-primary));
    box-sizing: border-box;
    width: 236px;
    border-radius: 8px;
  }
  .ncp-panel--picker {
    width: 260px;
  }

  .ncp-palette-grid {
    display: grid;
    grid-template-columns: repeat(8, 24px);
    column-gap: 4px;
    row-gap: 4px;
    align-content: start;
    max-height: min(240px, 42vh);
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    min-height: 0;
  }
    nile-popover#color-picker-popover::part(popover) {
     min-width: 236px;
     gap: 0px;
     padding: 4px;
    }

  /* no fill */
  .ncp-no-fill {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    margin-top: 8px;
    padding: 8px 0;
    border: 1px solid var(--nile-colors-neutral-500, var(--ng-colors-border-secondary));
    border-radius: 8px;
    background: var(--nile-colors-white-base, var(--ng-colors-bg-primary));
    color: var(--nile-colors-dark-500, var(--ng-colors-text-secondary-700));
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s ease;
  }
  .ncp-no-fill:hover { background: var(--nile-colors-neutral-100, var(--ng-colors-bg-primary-hover)); }

  /* custom section */
  .ncp-custom-section {
    margin-top: 16px;
    padding-top: 8px;
    border-top: 1px solid var(--nile-colors-neutral-500, var(--ng-colors-border-secondary));
  }
  .ncp-custom-title {
    margin: 0 0 8px;
    color: var(--nile-colors-dark-500, var(--ng-colors-text-secondary-700));
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    font-weight: 500;
  }
  .ncp-custom-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
  }
  /* tooltip wrappers default to inline — must be block so flex aligns them correctly */
  .ncp-custom-row nile-lite-tooltip {
    display: block;
    line-height: 0;
  }
  .ncp-custom-row nile-color-swatch {
    display: block;
  }
  .ncp-action-btn {
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    border: 1.5px solid var(--nile-colors-neutral-400, var(--ng-colors-border-primary));
    background: var(--nile-colors-white-base, var(--ng-colors-bg-primary));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-primary-900));
    cursor: pointer;
    box-sizing: border-box;
    padding: 0;
    transition: transform 0.15s ease, border-color 0.15s ease, background 0.15s ease;
  }
  .ncp-action-btn:hover {
    border-color: var(--nile-colors-neutral-500, var(--ng-colors-border-secondary));
    background: var(--nile-colors-neutral-100, var(--ng-colors-bg-primary-hover));
    transform: translateY(-1px);
  }
  .ncp-plus-icon {
    position: relative;
    width: 12px;
    height: 12px;
  }
  .ncp-plus-icon::before,
  .ncp-plus-icon::after {
    content: '';
    position: absolute;
    left: 50%; top: 50%;
    background: currentColor;
    transform: translate(-50%,-50%);
    border-radius: 999px;
  }
  .ncp-plus-icon::before { width: 12px; height: 2px; }
  .ncp-plus-icon::after  { width: 2px; height: 12px; }

  /* ── picker panel ───────────────────────────────────────────────── */
  .ncp-sv-area {
    position: relative;
    width: 244px;
    height: 130px;
    border-radius: 8px;
    overflow: hidden;
    cursor: crosshair;
    user-select: none;
  }
  .ncp-sv-canvas { display: block; width: 100%; height: 100%; }
  .ncp-sv-thumb {
    position: absolute;
    width: 20px; height: 20px;
    transform: translate(-50%,-50%);
    pointer-events: none;
  }
  .ncp-sv-thumb-inner {
    width: 20px; height: 20px;
    border-radius: 50%;
    border: 2.5px solid #FFFFFF;
    box-shadow: 0 0 0 1px rgba(0,0,0,0.15), 0 2px 6px rgba(0,0,0,0.2);
    box-sizing: border-box;
  }

  .ncp-hue-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 14px;
  }
  .ncp-hue-wrap {
    position: relative;
    flex: 1;
    height: 14px;
    border-radius: 7px;
    overflow: hidden;
    cursor: pointer;
    user-select: none;
  }
  .ncp-hue-canvas { display: block; width: 100%; height: 100%; border-radius: 7px; }
  .ncp-hue-thumb {
    position: absolute;
    top: 50%;
    width: 18px; height: 18px;
    border-radius: 50%;
    border: 2.5px solid #FFFFFF;
    box-shadow: 0 0 0 1px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.18);
    transform: translate(-50%,-50%);
    pointer-events: none;
    box-sizing: border-box;
  }
  .ncp-eyedropper {
    width: 28px; height: 28px;
    display: flex; align-items: center; justify-content: center;
    border: none; background: none;
    color: var(--nile-colors-dark-500, var(--ng-colors-text-secondary-700)); cursor: pointer; padding: 0; border-radius: 6px;
  }
  .ncp-eyedropper:hover { background: var(--nile-colors-neutral-100, var(--ng-colors-bg-primary-hover)); }

  .ncp-input-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 14px;
  }
  /* Safari: display:block needed so the custom element participates in flex layout */
  .ncp-input-row .ncp-mode-dropdown { display: block; flex-shrink: 0; width: 62px; min-width: 62px; }
  .ncp-input-row .ncp-mode-dropdown nile-button.ncp-mode-btn { width: 100%; min-width: 0; white-space: nowrap; }
  .ncp-input-row .ncp-mode-dropdown nile-button.ncp-mode-btn::part(base) {
    padding: 0 6px; width: 100%; min-width: 0; font-size: 11px; gap: 2px;
  }
  /* Safari: custom elements default to display:inline — must be block to flex-grow */
  .ncp-input-row nile-input.ncp-hex { display: block; flex: 1; min-width: 0; }
  .ncp-input-row nile-input.ncp-rgb { display: block; flex: 1; min-width: 0; }
  .ncp-input-row nile-input.ncp-rgb::part(input)::-webkit-inner-spin-button,
  .ncp-input-row nile-input.ncp-rgb::part(input)::-webkit-outer-spin-button { -webkit-appearance: none; }

  .ncp-picker-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
  }
`; }
